import { useI18n } from '~/common/context';
import { EditableTextField as BaseEditableTextField } from '@wyz/ui';
import * as React from 'react';

type EditableTextFieldProps = React.ComponentProps<
  typeof BaseEditableTextField
>;

const EditableTextField: React.FC<Omit<EditableTextFieldProps, 'translate'>> = (
  props,
) => {
  const { t } = useI18n();

  return <BaseEditableTextField {...props} translate={t} />;
};

export default EditableTextField;
